import { render, staticRenderFns } from "./AuthPage.vue?vue&type=template&id=459ae73d&scoped=true&"
import script from "./AuthPage.vue?vue&type=script&lang=ts&"
export * from "./AuthPage.vue?vue&type=script&lang=ts&"
import style0 from "./AuthPage.vue?vue&type=style&index=0&lang=scss&"
import style1 from "./AuthPage.vue?vue&type=style&index=1&id=459ae73d&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "459ae73d",
  null
  
)

export default component.exports